import { useEffect } from "react";

import { PushBroadCastChannel } from "~/features/push-notifications/broadcast-channel";

import { datadogRum } from "@datadog/browser-rum";

export const usePushTracing = () => {
  useEffect(() => {
    return PushBroadCastChannel.listen((message) => {
      datadogRum.addAction("web_push_received", {
        messageId: message.id,
        ...message,
      });
    });
  }, []);
};
